import { useState, useEffect } from "react";
import axiosService from "../../utils/axios.service";
import Avatar from 'react-avatar';
import CurrencyInput from "react-currency-input-field";
import ReactTooltip from "react-tooltip";
import { SnippetsOutlined } from '@ant-design/icons';
import { Modal, Input } from 'antd';
import { customDiscount, selectOptionTypePresenter } from "./constant/PosCustomer";
import { notifications } from "../constant/Notify";
import * as convert from "../constant/Convert.helper";
import PosOrderItemListUser from "./PosOrderItemListUser";
import { comboPackages } from "../../enums/comboPackages.enum";
const { TextArea } = Input;
let _ = require('lodash');

export default function PosOrderItemList(props) {
  const [discount, setDiscount] = useState(0);
  const [priceProps, setPriceProps] = useState(props.item.price);
  const [priceDiscount, setPriceDiscount] = useState(0);
  const [quantityInput, setQuantityInput] = useState(props.item.quantity);
  const [searchOperators, setSearchOperators] = useState("");
  const [statusSearchCustomer, setStatusSearchCustomer] = useState(false);
  const [dataSearchCustomer, setDataSearchCustomer] = useState([]);
  const [note, setNote] = useState("")
  const [show, setShow] = useState(false)
  const [customerFamily, setCustomerFamily] = useState(props.item?.customer_family ?? [])

  useEffect(() => {
    defaultValueOrderItem();
  }, [props]);

  let item = props.item;
  item.discount = item.discount ?? 0;

  item["service"] = item.service ?? []
  item["consultant"] = item.consultant ?? [];

  let services = [];
  if (props.services && props.services.length > 0) {
    services = props.services;
  }

  const defaultValueOrderItem = () => {
    var discountInput = 0;
    var selectDefaultDiscount = 0;
    if (props.item.discount) {
      discountInput =
        (props.item.discount * 100) /
        (props.item.price * props.item.quantity);
      if (!Number.isInteger(discountInput)) {
        discountInput = 0;
      }
    }
    if (!props.item.discount) {
      props.item.discount = 0;
    }

    setPriceProps(props.item.price)
    setQuantityInput(props.item.quantity)
    setDiscount(discountInput);
    setPriceDiscount(props.item.discount);
    setCustomerFamily(props.item?.customer_family ?? [])
    setNote(props.item.note ?? "")
  };

  if (item.quantity === 0) return null;

  const handleChangeQuantity = (item) => {
    let itemSelected = props.itemSelected;
    let keySelected = _.findIndex(itemSelected, function (o) { return o.id_item == props.item.id_item; });
    itemSelected[keySelected].quantity =
      Number(item.target.value); 
    props.onUpdateItems(itemSelected);
    setQuantityInput(Number(item.target.value));
  };

  const handleButtonQuantity = (itemChange, quantity, evt) => {
    let itemSelected = props.itemSelected;

    let keySelected = _.findIndex(itemSelected, function (o) { return o.id_item == itemChange.id_item; });

    let dataCombo = []
    if (itemChange.combo_id) {
      dataCombo = _.filter(itemSelected, function (o) { return o.combo_id == itemChange.combo_id; });
    }

    let code = (itemChange.package_code && itemChange.price == 0) ? itemChange.package_code : itemChange.product_code;
    var service = null;
    if (services.length > 0) {
      services.map((val) => {
        if (code == val.package_code) {
          service = val;
        }
      });
    }
    let count_used = 1;
    if (service) {
      count_used = service.max_used - service.count_used - parseInt(itemSelected[keySelected].quantity) - quantity + 1;
      if (count_used < 0) {
        count_used = 0;
      }
    }

    if (count_used > 0) {
      if (!itemChange.combo_id) {
        itemSelected[keySelected].quantity = parseInt(itemSelected[keySelected].quantity) + quantity;
        if (itemSelected[keySelected] && itemSelected[keySelected].discount > 0) {
          itemSelected[keySelected].discount = (itemSelected[keySelected].discount / (itemSelected[keySelected].quantity - quantity)) * itemSelected[keySelected].quantity;
        }
      }
      itemSelected.map((val, key) => {
        if (itemChange.combo_id && itemChange.combo_id == val.combo_id) {
          itemSelected[key].quantity = parseInt(itemSelected[keySelected].quantity) + quantity;
        }
      });
      props.onUpdateItems(itemSelected);
      setQuantityInput(itemSelected[keySelected].quantity);
    }

  };

  const addOrderItem = (data) => {
    let itemSelected = props.itemSelected

    let dataItem = {
      ...data,
      id: null,
      id_item: null
    };
    itemSelected.push(dataItem);
    props.onUpdateItems(itemSelected);
  }

  const handleRemoveItem = (itemChange) => {
    let itemSelected = props.itemSelected;
    let keySelected = _.findIndex(itemSelected, function (o) { return o.id_item == itemChange.id_item; });

    itemSelected[keySelected].quantity = 0;
    itemSelected[keySelected].discount = 0;
    props.onUpdateItems(itemSelected);
    setQuantityInput(itemSelected[keySelected].quantity);
  };

  const changeDataCommission = (type, data, event) => {
    let itemSelected = props.itemSelected;
    let keySelected = _.findIndex(itemSelected, function (o) { return o.id_item == props.commission; });
    let newItemSelected = itemSelected[keySelected][type] ?? [];


    if (!event.target.className.includes("active")) {
      if (Object.keys(newItemSelected).length < 5)
        newItemSelected = { ...newItemSelected, [data.id]: data };
    } else {
      Object.entries(itemSelected[keySelected][type]).map((item, key) => {
        if (item[0] == data.id) delete newItemSelected[data.id];
      });
    }

    itemSelected[keySelected][type] = newItemSelected;
    props.onUpdateItems(itemSelected);
  };

  const selectAllDataCommission = (data) => {
    let itemSelected = props.itemSelected;
    const { consultant, service, price } = data;

    Object.entries(itemSelected).forEach(([key, item]) => {
      if (price > 0 && item.price > 0) {
        itemSelected[key] = {
          ...item,
          consultant,
        };
      }

      if (price === 0 && item.price === 0) {
        itemSelected[key] = {
          ...item,
          service,
        };
      }
    });

    props.onUpdateItems(itemSelected);

    notifications({
      type: "success",
      mess: "Áp dụng cho mọi đơn hàng thành công",
    });

    props.handleChangeState("", "commission");
  };

  //Action Popup
  const showAction = (e) => {
    let listEl = document.getElementsByClassName(
      "order-details-dropdown-container"
    );
    if (e.target.classList.contains("active"))
      return e.target.classList.remove("active");

    Object.entries(listEl).map(function (item) {
      item[1].classList.remove("active");
    });
    e.target.classList.add("active");
  };

  const saveDataChange = () => {
    let key = _.findIndex(props.itemSelected, function (o) { return o.id_item == props.item.id_item; });
    props.itemSelected[key] = {
      ...props.itemSelected[key],
      price: Number(priceProps),
      customer_family: customerFamily
    };

    props.onUpdateItems(props.itemSelected);
    props.handleChangeState("", "statusActionItem");
  };

  const changeDataPricePopup = (event) => {
    let dataPrice = event.target.value.replaceAll(",", "");
    setPriceProps(dataPrice);
    setPriceDiscount((discount * (dataPrice * Number(quantityInput))) / 100);
  };


  const showEditOrderItem = (value, key) => {
    props.handleChangeState(value, key)
  }

  const handleNotePackage = () => {
    setShow(true)
  }
  const handleOk = () => {
    const selectI = props.itemSelected
    const newData = {
      ...selectI[item.code],
      note: note
    }
    setShow(false)
    selectI[item.code] = newData
    props.onUpdateItems(selectI);
  }
  const handleCancel = () => {
    setShow(false)
  }
  const handleChangeNote = (e) => {
    setNote(e.target.value)
  }

  const searchCustomer = _.debounce(async (event) => {
    let keyword = event.target.value;
    if (keyword.length >= 2) {
      let {data} = await axiosService("api/customer?keyword=" + keyword, "GET")
      if (data.success) {
        const response = data.data.data;
        setDataSearchCustomer(response ?? []);
        setStatusSearchCustomer(true);
      }
    }
  }, 500);

  const getDetailCustomer = (data, type) => {
    setCustomerFamily((prev) => {
      if (type === "add") {
        const isExist = prev.some((item) => item.id === data.id);
        if (isExist || (customerFamily.length+1) === props.item.number_family || props.customerId == data.id) return prev;
        return [...prev, data];
      }

      if (type === "remove") {
        return prev.filter((item) => item.id !== data.id);
      }

      return prev;
    });
  };

  return (
    <tr>
      <Modal title="Tạo ghi chú cho thẻ" open={show} onOk={handleOk} onCancel={handleCancel}>
        <TextArea rows={4} placeholder="Ghi chú cho thẻ" onChange={handleChangeNote} value={note} />
      </Modal>
      <td className="col-full" style={{ cursor: "pointer", position: "relative" }}>
        <div className="item-info">
          <div>
              <span className="ng-binding">
                {[1,2,4].includes(props?.typeOrder) ? "Nâng cấp " : (item.new_package) ? "Mua " : (item.package_code) ? "Sử dụng " : null} 
                {item.product_name} {item.is_convert_bhvv == 1 || item.package?.is_convert_bhvv == 1 ? " - CD" : ""}
              </span>
            {item.combo_id ?  
              <p><span style={{color: "red"}}> {item.combo_name}</span></p>
            : null} 
          </div>
          <div className="text-grey font-11 ng-binding ng-scope">
            Giá:
            <span currency-filter="" className="ng-isolate-scope">
              <span className="cash-vnd">
                {convert.convertCurrency(item.price)}
                {[1,2,4].includes(props?.typeOrder) && (item?.upgrade_by_package != '' && item?.upgrade_by_package)? " / " + item.max_used + " buổi" : null}
              </span>
            </span>
          </div>
        </div>
      </td>
      <td className="col-half">
        <div className="input-group">
          {(props.item.new_package && props.item.price > 0) ?
            <SnippetsOutlined className="note-package" onClick={handleNotePackage} />
          : null}
          <span className="input-group-btn">
            {[1,2,4].includes(props?.typeOrder) ?
              <button className="btn left btn-xs btn-default btn-icon" type="button"></button>
            :    
              <button className="btn left btn-xs btn-default btn-icon" type="button" onClick={handleButtonQuantity.bind(this, item, -1)}>
                <i className="fa-solid fa-minus"></i>
              </button>
            }
          </span>
          <input readOnly className="form-control" value={item.quantity} onChange={handleChangeQuantity} />
          {!item.combo_id ?
            <span className="input-group-btn right">
              {item.new_package ?
                [1,2,4].includes(props?.typeOrder) ?
                  <button className="btn right btn-xs btn-default" type="button"></button>
                : 
                  <button className="btn right btn-xs btn-default" type="button" onClick={(item.new_package) ? addOrderItem.bind(this, item) : handleButtonQuantity.bind(this, item, 1)}>
                    <i className="fa-solid fa-plus"></i>
                  </button>
              : item.package ?
                !((item.package.parent_package != null) && (!comboPackages.includes(item.package.product_id)) || (item.package.parent_package == null) && (comboPackages.includes(item.package.product_id))) ?
                  <button className="btn right btn-xs btn-default" type="button" onClick={(item.new_package) ? addOrderItem.bind(this, item) : handleButtonQuantity.bind(this, item, 1)}>
                    <i className="fa-solid fa-plus"></i>
                  </button>
                : 
                  <button className="btn right btn-xs btn-default" type="button"></button>
              :
                ![1,2,4].includes(props?.typeOrder) && 
                !props.waxing_head.includes(Number(item.product_id)) && 
                !((item.parent_package != null) && (comboPackages.includes(Number(item.product_id)))) &&
                ((item.parent_package == null)|| (!comboPackages.includes(item.product_id))) ?
                  <button className="btn right btn-xs btn-default 3" type="button"onClick={addOrderItem.bind(this, item)}>
                    <i className="fa-solid fa-plus"></i>
                  </button> 
                :
                  <button className="btn right btn-xs btn-default" type="button"></button>
              }
            </span>
          : 
            <span className="input-group-btn right disable-package2">
                <button className="btn right btn-xs btn-default" type="button"><i className="fa-solid fa-plus"></i></button>
            </span>
          }
        </div>
      </td>
      <td className="text-center has-tooltip-info col-half">
        <div className="require-operator operator_avatar_group"
          style={{ cursor: "pointer" }}
          onClick={() => props.handleChangeState(item.id_item, "commission")}
          data-tip data-for={"service-user-" + (props.item.package_code ?? props.item.code)}>
          {Object.entries(item.service).length > 0 ?
            <span className="count service">{Object.entries(item.service).length}</span>
          : null}

          {Object.entries(item.service).length > 0 || Object.entries(item.consultant).length > 0 ?
            <Avatar 
              name={Object.entries(item.service).length > 0 ? Object.entries(item.service)[0][1].name : Object.entries(item.consultant)[0][1].name} 
              size="36" textSizeRatio={1.75} round="50%" />
            : <i className="fas fa-question snake-gift"></i>}

          {Object.entries(item.consultant).length > 0 ?
            <span className="count consultant">{Object.entries(item.consultant).length}</span>
          : null}

          {Object.entries(item.service).length > 0 || Object.entries(item.consultant).length > 0 ?
            <ReactTooltip className="tooltip-user" place="bottom" type="dark" id={"service-user-" + (props.item.package_code ?? props.item.code)}>
              {Object.entries(item.service).length > 0 ?
                <div className="item-user">
                  <label>Nhân viên phục vụ</label>
                  {Object.entries(item.service).map((data, key) => (
                    <p key={key}>- {data[1].name}</p>
                  ))}
                </div>
              : null}

              {Object.entries(item.consultant).length > 0 ?
                <div className="item-user">
                  <label>Nhân viên tư vấn</label>
                  {Object.entries(item.consultant).map((data, key) => (
                    <p key={key}>- {data[1].name}</p>
                  ))}
                </div>
                : null}
            </ReactTooltip>
            : null}
        </div>
      </td>
      <td className="col-half">
        <span className="title hide-desktop">Thành tiền</span>
        <span className="text-bold price-subtotal">
          <span className="cash-vnd text-bold pull-right">
            {convert.convertCurrency((item.price - item.discount) * item.quantity)}
          </span>
          {item.discount > 0 ? 
            <p className="show-total-discount">
              {convert.convertCurrency(item.price * item.quantity)}
            </p>
          : null}
        </span>
      </td>
      <td className="col-half">
        <div className="order-details-dropdown-container pull-right btn btn-default dropdown-toggle" onClick={showAction}>
          {props.isDeposit || props.item.number_family > 0 || ![1,2,4].includes(props?.typeOrder) ?
            <ul className="dropdown-menu">
              {props.isDeposit || props.item.number_family > 0 ?
                <li className="action edit" onClick={() => showEditOrderItem(item.id_item, "statusActionItem")}>
                  <i className="fas fa-pen"></i>Sửa
                </li> 
              :null}
              {![1,2,4].includes(props?.typeOrder) ?
                <li className="action remove" onClick={() => handleRemoveItem(item)} >
                  <i className="fas fa-trash-alt"></i> Xóa
                </li>
              :null}
            </ul>
          :null}
          
        </div>
      </td>
      {props.commission == item.id_item ? (
        <td className="selected-operator">
          <div className="content-data">
            <div className="close" onClick={() => props.handleChangeState("", "commission")}>×</div>
            <div className="content-operator">
              <div className="head-block">
                <div className="select-all" onClick={() => selectAllDataCommission(item)}>
                  Áp dụng lựa chọn cho toàn bộ đơn hàng
                </div>
                <div className="title-block">Tìm kiếm</div>
                <div className="input-search">
                  <input type="text" name="selected-operator" defaultValue={searchOperators} onChange={(e) => setSearchOperators(e.target.value)} />
                </div>
              </div>
              <div className="body-operators">
                <div className="top-title">
                  <div className="top-name d-flex justify-content-between">Nhân viên<div style={{ cursor: "pointer" }} onClick={props.handleSortName}>
                    {props.isAscOperator ? <i className="fa-solid fa-arrow-down-wide-short mr-4"></i> : <i className="fa-solid fa-arrow-up-wide-short mr-4"></i>}
                  </div></div>
                  <div className="top-name">Phục vụ</div>
                  <div className="top-name">Tư vấn</div>
                </div>
                <div className="list-operator">
                  {props.listOperator.map((operator, key) => (
                    <PosOrderItemListUser
                      key={key}
                      operator={operator}
                      changeDataCommission={changeDataCommission}
                      item={item}
                      searchOperators={searchOperators}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="overlay-user-list" onClick={() => props.handleChangeState("", "commission")}></div>
        </td>
      ) : null}

      {props.statusActionItem === item.id_item ? (
        <td className="change-price-item" onClick={() => setStatusSearchCustomer(false)}>
          <div className="popup-cent update-cart-item">
            <div className="content-popup fadeInDown">
              <div className="head-popup">
                <div className="title">Chỉnh sửa thông tin đơn hàng</div>
                <div className="close" onClick={() => props.handleChangeState("", "statusActionItem")}>×</div>
              </div>
              <div className="body-popup">
                <div className="order-item-details">
                  <div className="info">
                    <div className="order-item-name">
                      {item.package_code ? "Sử dụng " : ""} {item.product_name}
                    </div>
                    <div className="order-code">{item.code}</div>
                  </div>
                  <div className="pull-right cash-vnd total-price">
                    <div>{convert.convertCurrency(priceProps)}</div>
                    <div className="show-discount">{convert.convertCurrency(priceDiscount)}</div>
                  </div>
                </div>
                {props.isDeposit ?
                  <div className="price-change">
                    <div className="item-input">
                      <div className="label">Giá</div>
                      <div className="value">
                        <CurrencyInput
                          defaultValue={priceProps}
                          groupSeparator={","}
                          decimalSeparator={"."}
                          disabled={!props.isDeposit}
                          onChange={(e) => changeDataPricePopup(e)}
                        />
                        <div className="currency">₫</div>
                      </div>
                    </div>
                  </div>
                :null}
                {props.item.number_family > 0 ?
                  <div className="family-change">
                    <div className="search-family">
                      <div className="label">{`Chọn khách đồng sở hữu (Tối đa: ${props.item.number_family} khách)`}</div>
                      <input className="input-search-cus" placeholder="Tìm khách hàng theo tên hoặc số điện thoại" type="text" onChange={searchCustomer}/>
                      {statusSearchCustomer === true ? 
                        <div className="result-search">
                          {dataSearchCustomer.length === 0 ? 
                            <div className="empty-customer">
                              Không tìm thấy dữ liệu phù hợp
                            </div>
                          : 
                            <div className="items-customer">
                              {dataSearchCustomer.map((data, key) => (
                                <div className="item" key={key} onClick={() => {getDetailCustomer(data, "add")}}>
                                  <div className="avatar">
                                    {data.avatar_url ?
                                      <img src={data.avatar_url} alt="" />
                                    : <Avatar name={data.full_name} size="46" textSizeRatio={1.75} round="50%" />}
                                  </div>
                                  <div className="info">
                                    <div className="name">
                                      {data.full_name}
                                      {data?.identifier === 1 ? <span className="identifier-customer"><img src="/icons/verified.png" /></span> : ""}
                                    </div>
                                    {data?.waxing_type >= 1 && data?.status_head_waxing === 0 ? <div style={{fontSize: '11px', color: "#999", marginTop: '8px'}}>(Chưa tặng đầu triệt)</div>  : ""}
                                    {data.deposit_money > 0 ?
                                      <div className="deposit">Tài khoản: {convert.convertCurrency(data.deposit_money)}</div>
                                    : null}
                                    <div className="phone">{data.mobile}</div>
                                    <div className="address">{data.district} - {data.city}</div>
                                  </div>
                                </div>
                              ))}
                            </div>
                          }
                        </div>
                      : null}
                    </div>
                    <div className="list-family">
                      <div className="row">
                        {customerFamily.map((data, key) => (
                          <div className="col-12 col-md-6" key={key}>
                            <div className="wrapper-item">
                              <div className="column-info">
                                <div className="avatar">
                                  {data.avatar_url ?
                                    <img src={data.avatar_url} alt="" />
                                  : <Avatar name={data.full_name} size="46" textSizeRatio={1.75} round="50%" />}
                                </div>
                                <div className="info">
                                  <div className="name">
                                    {data.full_name}
                                  </div>
                                  <div className="phone">{data.mobile}</div>
                                </div>
                              </div>
                              <div className="column-action" onClick={() => {getDetailCustomer(data, "remove")}}>Xóa</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                :null}
              </div>
              <div className="bottom-popup">
                <div className="button-container">
                  <div className="button-cent style3" onClick={() => props.handleChangeState("", 'statusActionItem')}>
                    <span><i className="fas fa-times"></i></span>Đóng
                  </div>
                  <div className="button-cent" onClick={saveDataChange}>
                    <span><i className="fas fa-save"></i></span>Lưu thông tin
                  </div>
                </div>
              </div>
            </div>
            <div className="overlay" onClick={() => props.handleChangeState("", 'statusActionItem')}></div>
          </div>
        </td>
      ) : null}
    </tr>
  );
}
